
import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import {
  RetrievePreFlashLogResponseBody,
  RetrievePostFlashLogResponseBody,
} from '../entities/flash-log-v1';
import { BulkFlashRequestInput, modemOnlyFlashRequset  } from './types';
import { axiosInstance } from "../axios-instance";

class BulkDeviceFlashLogs {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  preFlash(input: BulkFlashRequestInput): Promise<AxiosResponse<RetrievePreFlashLogResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    const { body, deviceKey } = input;
    const device = deviceKey ? `?deviceKey=${deviceKey}` : ``;
    return axiosInstance.post<any>(`${this.baseUrl}/retrievePreFlashLogs${device}`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/octet-stream',
      },
    });
  }

  postFlash(
    input: BulkFlashRequestInput,
  ): Promise<AxiosResponse<RetrievePostFlashLogResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    const { body, deviceKey } = input;
    const device = deviceKey ? `?deviceKey=${deviceKey}` : ``;
    return axiosInstance.post<any>(`${this.baseUrl}/retrievePostFlashLogs${device}`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/octet-stream',
      },
    });
  }

  uploadSIMCredentialingCSV(input: any, bootstrapActionType?: string): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    let headerValues: any = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'multipart/form-data',
    }
    if (!bootstrapActionType || bootstrapActionType !== "Bootstrap") {
      headerValues = {
        ...headerValues,
        'X-Cat-Sim-Recredential-Type': bootstrapActionType,
      }
    }
    return axiosInstance.post<any>(`${this.baseUrl}/bulkSimRecredential`, input, {
        headers: headerValues  
    });
  }

  uploadEngineeringTemplateCSV(input: any): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<any>(`${this.baseUrl}/simRecredentialStatus/search`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  getSimRecredentialStatus(input: any): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<any>(`${this.baseUrl}/SimRecredentialStatus`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
  }

  queueShortMessage(input: any): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<any>(`${this.baseUrl}/shortMessageRequest/v1/queueConfigs`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
  }

  queueShortComand(input: any): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<any>(`${this.baseUrl}/shortCommands/v1/queueCommands`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
  }

  queueModemFirmware(input:modemOnlyFlashRequset):Promise<AxiosResponse<any>>{
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<any>(`${this.baseUrl}/queueModemFirmware`,input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
  }

  modemFirmwareStatus(input:any):Promise<AxiosResponse<any>>{
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<any>(`${this.baseUrl}/modemFirmwareStatuses/search`,input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
  }
}

export default BulkDeviceFlashLogs;
